import React from 'react';
import { Button } from '@/components/ui/button';
import { DateSelector } from '@/components/admin/sales/DateSelector';
interface SalesDashboardHeaderProps {
  title: string;
  role: string | null;
  isResetting: boolean;
  resetMessage: string;
  selectedDate: Date | undefined;
  onDateChange: (date: Date | undefined) => void;
  onApply: (date: Date | undefined) => void;
  onResetMetrics: () => void;
}
export const SalesDashboardHeader: React.FC<SalesDashboardHeaderProps> = ({
  title,
  role,
  isResetting,
  resetMessage,
  selectedDate,
  onDateChange,
  onApply,
  onResetMetrics
}) => {
  return <div className="flex justify-between mb-4">
      
      <DateSelector date={selectedDate} onDateChange={onDateChange} onApply={onApply} />
    </div>;
};